/**
 * @desc 获取运单信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/test/testGetLogisticsInfo`, {
      method: "POST",

      ...options,
    }),
  );
}
